import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Dropdown from './dropdown';
import uiActions from 'state/actions/ui';
import CONSTANTS from 'constants/state';
import './mega-menu-categories.scss';
import MegaCategories from './mega-categories.json';
/**
 * @description - MegaMenuCategories is *currently* only used on the homepage
 * It renders the 'mega' menu below the main navigation, showcasing multiple categories,
 * searches and shops to show visitors what Tradera has to offer.
 * @class MegaMenuCategories
 * @extends {Component}
 */
class MegaMenuCategories extends Component {
    static displayName = 'MegaMenu';
    static propTypes = {
        selected: PropTypes.number,
        open: PropTypes.string.isRequired
    };

    open = index => {
        const { dispatch } = this.props;
        dispatch(uiActions.openMegaMenu(index));
    };

    close = () => {
        const { dispatch } = this.props;
        dispatch(uiActions.closeMegaMenu());
    };

    render() {
        const { open, selected } = this.props;

        const ListItem = (category, index) => {
            const itemOpen = selected === index && open === CONSTANTS.MENU.OPEN;
            return (
                <li
                    className={`nav-item flex-fill flex-shrink-1 dropdown ${
                        itemOpen ? 'bg-white' : ''
                    }`}
                    key={category.header}
                    onClick={() =>
                        itemOpen ? this.close(index) : this.open(index)
                    }
                    onMouseEnter={() => this.open(index)}
                    onMouseLeave={() => this.close(index)}
                    role="tab">
                    <p
                        title={category.header}
                        className={`nav-link text-center mb-0 dropdown-toggle ${
                            itemOpen ? 'text-dark' : 'text-white'
                        }`}>
                        {category.header}
                    </p>
                    {itemOpen && <Dropdown category={MegaCategories[index]} />}
                </li>
            );
        };

        return (
            <nav className="mega-menu container d-none d-md-flex bg-dark">
                <ul className="nav nav-fluid d-flex flex-nowrap col-12">
                    {MegaCategories.map(ListItem)}
                </ul>
            </nav>
        );
    }
}
const mapStateToProps = (state, ownProps) => ({
    open: state.ui.megaMenu.open,
    selected: state.ui.megaMenu.selected,
    ...ownProps
});

export default connect(mapStateToProps)(MegaMenuCategories);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/mega-menu-categories/mega-menu-categories.jsx